import { ButtonTypeMap } from '@material-ui/core';
import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@material-ui/core/IconButton';

import * as React from 'react';
import styled from 'styled-components';
import { getStyleForColor, stripDefaultColors } from '../DSButton';

function WrappedMuiIconButton<D extends React.ElementType = ButtonTypeMap['defaultComponent']>({
    color,
    ...rest
}: DSIconButtonProps<D>) {
    return <MuiIconButton {...rest} color={stripDefaultColors(color)} />;
}
WrappedMuiIconButton.displayName = 'WrappedMuiIconButton';

const StyledIconButton = styled(WrappedMuiIconButton)`
    ${({ color, theme }) => getStyleForColor({ color, theme, variant: 'text' })}
`;

export type DSIconButtonProps<T extends React.ElementType = 'button'> = Omit<
    MuiIconButtonProps<T, { component?: T }>,
    'color'
> & {
    ['data-cy']?: string;
    color?: 'default' | 'error' | 'info' | 'inherit' | 'primary' | 'secondary' | 'success' | 'warning';
};
export function DSIconButton<T extends React.ElementType>(props: DSIconButtonProps<T>): JSX.Element {
    return <StyledIconButton disableRipple {...props} />;
}
DSIconButton.displayName = 'DSIconButton';
